<template>
  <div class="d-flex flex-column rounded pb-4 card elevation-3">
    <div class="image-wrapper d-flex flex-column justify-center rounded-t mb-4">
      <v-icon x-large color="black"> mdi-eye-off </v-icon>
      <div class="body-1 text-center">{{ $t('noImageAvailable') }}</div>
    </div>

    <v-divider class="mb-2"></v-divider>

    <div class="subtitle-1 font-weight-medium text-center mb-2">
      {{ museum.defaultTitle }}
    </div>

    <div class="d-inline-flex align-center justify-center">
      <v-btn
        class="align-self-center mr-3"
        color="warning lighten-1"
        small
        :lang="$i18n.locale"
        @click="$router.push({ path: `/superuser/museum/${museum.id}` })"
      >
        <v-icon left>mdi-pencil</v-icon>
        {{ $t('edit') }}
      </v-btn>

      <v-btn
        class="align-self-center"
        color="error"
        small
        :lang="$i18n.locale"
        @click="onOpenDeleteDialog(museum)"
      >
        <v-icon left>mdi-delete</v-icon>
        {{ $t('delete') }}
      </v-btn>
    </div>

    <v-dialog v-model="dialog.open" max-width="500px">
      <div class="white pa-5" v-if="dialog.open">
        <div class="body-1 text-center mb-4">
          {{ $t('deleteMuseum') }} <b>{{ dialog.museum.defaultTitle }}</b
          >;
        </div>

        <div class="d-flex justify-center">
          <v-btn
            small
            class="mr-2"
            @click="dialog.open = false"
            :lang="$i18n.locale"
          >
            {{ $t('cancel') }}
          </v-btn>

          <v-btn
            small
            color="error"
            @click="onDeleteMuseum"
            :loading="loader"
            :lang="$i18n.locale"
          >
            {{ $t('delete') }}
          </v-btn>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
  import { mapActions } from "vuex";

  export default {
    props: ["museum"],
    data() {
      return {
        dialog: {
          open: false,
          museum: null,
        },
        loader: false
      };
    },
    methods: {
      ...mapActions(["deleteMuseum", "getMuseums"]),
      onOpenDeleteDialog(museum) {
        this.dialog = {
          open: true,
          museum,
        };
      },
      async onDeleteMuseum() {
        this.loader = true;

        try {
          await this.deleteMuseum(this.dialog.museum.id);
          await this.getMuseums(true);
        } catch (e) {
          console.log(e);
        }

        this.loader = false;
        this.dialog.open = false;
      },
    }
  };
</script>

<style lang="scss" scoped>
  .card {
    border: 1px solid #e0e0e0;
    background-color: #fafafa;
  }

  .image-wrapper {
    height: 200px;
  }
</style>